/**
 * Object for sending to Audiomanager.play() function.
 * Single audio playback is contained in this object.
 * Things to note:
 *  1. isAudioSprite is true and
 */
const AudioPlayOption = cc.Class({
    name: 'AudioPlayOption',
    properties: {
        clip: {
            type: cc.AudioClip,
            default: null,
            visible: function() { return !this.isAudioSprite }
        },
        isAudioSprite: true,
        spriteName: {
            default: '',
            visible: function() { return this.isAudioSprite }
        },
        volume: {
            default: 1.0,
            type: cc.Float,
            range: [0, 1, 0.1],
            slide: true,
        },
        count: {
            default: 1,
            type: cc.Integer,
            visible: function() { return !this.loop && !this.oneShot }
        },
        loop: {
            default: false,
            visible: function() { return this.count > 0 && !this.oneShot }
        },
        isMusic: {
            default: false,
        },
        musicTrack: {
            default: 0,
            range: [0, 10, 1],
            visible: function() { return this.isMusic }
        },
        oneShot: {
            default: false,
            visible: function() { return !this.isMusic }
        },
        onAudioEndCallback: {
            default: null,
            visible: false,
            serializable: false
        },
        sideChain: {
            default: false,
            visible: true,
            serializable: true
        }
    },
});

export default AudioPlayOption;
